import { useState, useRef } from 'react';

/**
 * HTML5 drag-to-reorder for a list. Callers pass `dragProps(index)` onto each item.
 * On drop, `onReorder` receives a new array with `order` rewritten to 0..n-1.
 */
export function useDragSort(items, onReorder) {
  const dragIdx = useRef(null);
  const [overIdx, setOverIdx] = useState(null);

  const dragProps = (index) => ({
    draggable: true,
    onDragStart: (e) => {
      dragIdx.current = index;
      e.dataTransfer.effectAllowed = 'move';
    },
    onDragOver: (e) => {
      e.preventDefault();
      setOverIdx(index);
    },
    onDragLeave: () => setOverIdx(null),
    onDrop: (e) => {
      e.preventDefault();
      const from = dragIdx.current;
      const to = index;
      if (from !== null && from !== to) {
        const next = [...items];
        const [moved] = next.splice(from, 1);
        next.splice(to, 0, moved);
        onReorder(next.map((item, i) => ({ ...item, order: i })));
      }
      dragIdx.current = null;
      setOverIdx(null);
    },
    onDragEnd: () => {
      dragIdx.current = null;
      setOverIdx(null);
    },
  });

  return { overIdx, dragProps };
}
